import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { toast } from "sonner";

const STATUSES = ["pending_deposit", "deposit_paid", "confirmed", "completed", "cancelled"];

export default function AdminBookings() {
  const [items, setItems] = useState([]);
  const [filter, setFilter] = useState("");
  const load = () => {
    api.get("/admin/bookings", { params: filter ? { status_filter: filter } : {} })
      .then((r) => setItems(r.data))
      .catch(() => setItems([]));
  };
  useEffect(() => { load(); }, [filter]);

  const update = async (id, patch) => {
    try {
      await api.patch(`/admin/bookings/${id}`, patch);
      toast.success("Updated");
      load();
    } catch {
      toast.error("Update failed");
    }
  };

  return (
    <div data-testid="admin-bookings-page">
      <div className="flex items-end justify-between mb-8">
        <div>
          <div className="eyebrow text-[var(--crest-gold)]">— Bookings</div>
          <h1 className="font-serif text-4xl md:text-5xl tracking-tight mt-2">Consultation Bookings</h1>
        </div>
        <select className="crest-input max-w-xs" value={filter} onChange={(e) => setFilter(e.target.value)} data-testid="bookings-filter">
          <option value="">All Statuses</option>
          {STATUSES.map((s) => <option key={s}>{s}</option>)}
        </select>
      </div>

      <div className="admin-card overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="text-left text-[var(--crest-muted)] border-b border-black/10">
              <th className="py-3 px-2">Client</th>
              <th className="py-3 px-2">Email</th>
              <th className="py-3 px-2">Phone</th>
              <th className="py-3 px-2">Service</th>
              <th className="py-3 px-2">When</th>
              <th className="py-3 px-2">Status</th>
              <th className="py-3 px-2 text-right">Actions</th>
            </tr>
          </thead>
          <tbody>
            {items.length === 0 && (
              <tr><td colSpan={7} className="py-10 text-center text-[var(--crest-muted)]">No bookings yet.</td></tr>
            )}
            {items.map((b) => (
              <tr key={b._id} className="border-b border-black/5" data-testid={`booking-row-${b._id}`}>
                <td className="py-3 px-2 font-medium">{b.client_name}</td>
                <td className="py-3 px-2 text-[var(--crest-muted)]">{b.client_email}</td>
                <td className="py-3 px-2 text-[var(--crest-muted)]">{b.client_phone}</td>
                <td className="py-3 px-2">{b.service_interest}</td>
                <td className="py-3 px-2">{(b.consultation_datetime || "").toString().slice(0, 16).replace("T", " ")}</td>
                <td className="py-3 px-2">
                  <select className="crest-input text-xs" value={b.status} onChange={(e) => update(b._id, { status: e.target.value })} data-testid={`booking-status-${b._id}`}>
                    {STATUSES.map((s) => <option key={s}>{s}</option>)}
                  </select>
                </td>
                <td className="py-3 px-2 text-right text-xs gold tracking-widest uppercase">
                  {b.stripe_payment_intent_id ? "Paid" : b.stripe_checkout_session_id ? "Awaiting" : "—"}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
